import { render } from "./SidebarLoader.vue?vue&type=template&id=0c2c7457&scoped=true"
import script from "./SidebarLoader.vue?vue&type=script&lang=js"
export * from "./SidebarLoader.vue?vue&type=script&lang=js"

import "./SidebarLoader.vue?vue&type=style&index=0&id=0c2c7457&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c2c7457"]])

export default __exports__